import { useStaticQuery, graphql } from "gatsby"

const useBlogs = () => {
  const query = useStaticQuery(graphql`
  query bizAdvice {
    posts: allGhostPost(
        filter: { tags: { elemMatch: { slug: { eq: "eventshub" } } } }
        sort: { order: DESC, fields: [published_at] }
        limit: 1000
        skip: 0
    ) {
        edges {
            node {
                id
                title
                slug
                feature_image
                excerpt
                published_at(formatString: "DD MMMM YYYY")
                primary_author {
                    name
                    slug
                    profile_image
                }
                tags {
                    name
                    slug
                }
            }
        }
    }
  }
  `);

  return query;
}

export default useBlogs;
